export class AppConfig {

    static get APP_URL() {
        return window.location.origin;
    }

    static get GEONODE_URL() {
        return 'https://geoserver.sigo.app';
    }

    static get TEGOLA_URL() {
        return 'https://vinaros-tegola.sigoinfraestructuras.com/tegola/';
    }

    static get DIRECCIONES_URL() {
        return 'https://vinaros.sigoincidencias.com/callejero/direcciones';
    }

    static get INCIDENCIAS_URL() {
        return 'https://vinaros.sigoincidencias.com';
    }

    static get MAP_CENTER() {
        return [40.4691616, 0.478146];
    }

    static get BASE_LAYERS() {
        return [
            {
                name: 'Vinaros',
                url: "https://api.maptiler.com/maps/positron/{z}/{x}/{y}.png?key=uMXJSWTp92KTUiokUZBW",
                layerOptions: {maxZoom: 21}
            },
            // {
            //     name: 'OSM Completo',
            //     url: 'https://maps.tilehosting.com/styles/streets/{z}/{x}/{y}.png?key=iT5gkrA86HqqmDMFQQ1O',
            //     layerOptions: {
            //         attribution: "© OpenMapTiles © OpenStreetMap contributors"
            //     }
            // },
            {name: 'OSM', url: 'https://api.maptiler.com/maps/streets/{z}/{x}/{y}.png?key=uMXJSWTp92KTUiokUZBW'},
            // {name: 'Ortofoto ESRI', url: 'https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}'},
            {
                name: 'PNOA',
                url: "https://tms-pnoa-ma.idee.es/1.0.0/pnoa-ma/{z}/{x}/{-y}.jpeg"
            },
            // {
            //     name: 'PNOA', url: 'http://www.ign.es/wms-inspire/pnoa-ma',
            //     type: "wms",
            //     layerOptions: {
            //         "layers": "OI.OrthoimageCoverage",
            //         "format": "image/png",
            //         "transparent": true,
            //         "version": '1.3.0',//wms version (see get capabilities)
            //         "attribution": "PNOA WMS. Cedido por © Instituto Geográfico Nacional de España"
            //     }
            // }
        ];
    }

    static get DEFAULT_BASE_LAYER() {
        return AppConfig.BASE_LAYERS[0];
    }
}
